import React from 'react'

const Manual_admin_roles_administrador = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          Admin - Roles de Administrador
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          La guía ayuda a los administradores a gestionar roles de usuario, permitiendo revisar, editar permisos y crear nuevos roles. Esto optimiza la seguridad y eficiencia del sistema al asignar accesos según las responsabilidades.
        </p>
        <iframe
          src="https://scribehow.com/embed/Admin__Roles_de_Administrador__55-VaDGYT7uu6ADbr0YH_w?as=scrollable"
          className="scribe-iframe-general-48"
          width="100%"
          height="5650"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_admin_roles_administrador